export default __webpack_public_path__ + "static/media/pgmico(20).ab8fe0c6.png";